module.exports = __webpack_public_path__ + "static/media/doctor2.01759086.png";